import React, {useEffect, useState} from 'react';
import OnboardingNew from '../../stories/components/OnboardingNew/OnboardingNew';
import OtpVerified from '../../stories/components/OnboardingNew/CommonComponents/OtpVerified/OtpVerified';

const MultiUserOtpVerified = () => {
  return (
    <>
      <OnboardingNew step={1}>
        <OtpVerified
          heading="PAN Ownership Verified"
          headingIcon="./assets/green-tick.png"
          subHeading=""
          message="Continue to Create Account"
          responseRedirectUrl={'/agent/subuser/createaccount/'}
          //inportantInfo={`<span class='latoBlack'>*Important:</span> ${submitOtpSuccesData?.sub_heading}`}
          panVerified={true}
          //responseRedirectUrl={responseRedirectUrl}
        />
      </OnboardingNew>
    </>
  );
};

export default MultiUserOtpVerified;
